module.exports = __webpack_public_path__ + "images/apps/yiqixie-799c15bd6a3b3b83da7f227a2b4a70bd.png";